/**
 * 支付相关
 */

import axios from '../utils/http';

const goodsDetail = params => {
    return axios.request({
        data: {
          ...params
        },
        method: 'get',
        url: '/sell/goods/buyDetail2'
      })
}
const payConfig = params => {
  return axios.request({
    data: {
      ...params
    },
    method: 'post',
    url: '/v7/courseware/detail'
  })
}
//获取订单
const getOrder = params => {
    return axios.request({
    data: {
        ...params
    },
    method: 'post',
    url: '/v1/sell/order/h5/build'
    })
}

//微信支付
const WechatPay = params => {
    return axios.request({
        data: {
            ...params
        },
        methods: 'post',
        url: 'https://api.mch.weixin.qq.com/v3/pay/transactions/h5'
    })
}
//检查订单状态
const checkOrderStatus = params => {
    return axios.request({
    data: {
        ...params
    },
    method: 'post',
    url: '/v1/sell/order/h5/checkOrderPay'
    })
}
const pay = {
    goodsDetail,
    getOrder,
    payConfig,
    WechatPay,
    checkOrderStatus
};

export default pay